
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.79553 9.14742C3.79553 4.61626 7.46876 0.943024 11.9999 0.943024C16.5311 0.943024 20.2043 4.61625 20.2043 9.14741V16.1168H21.4207C21.973 16.1168 22.4207 16.5645 22.4207 17.1168C22.4207 17.6691 21.973 18.1168 21.4207 18.1168H19.2092L19.2043 18.1168H4.79553L4.7907 18.1168H2.5791C2.02682 18.1168 1.5791 17.6691 1.5791 17.1168C1.5791 16.5645 2.02682 16.1168 2.5791 16.1168H3.79553V9.14742ZM18.2043 9.14741V16.1168L5.79553 16.1168V9.14742C5.79553 5.72083 8.57333 2.94302 11.9999 2.94302C15.4265 2.94302 18.2043 5.72082 18.2043 9.14741ZM10.4695 21.5266C10.4695 22.3718 11.1547 23.057 11.9999 23.057C12.8451 23.057 13.5303 22.3718 13.5303 21.5266V21.4042C13.5303 20.559 12.8451 19.8738 11.9999 19.8738C11.1547 19.8738 10.4695 20.559 10.4695 21.4042V21.5266Z","fill":"#16171F"}})])
          )
        }
      }
    